import React from 'react';
import { ERoutes } from '../../../assets/constants/routes';

export function ExploreAlternativeListComponent() {
  const items = [
    { image: 'salon', title: 'Lilihome', at: '@Lilihome', locator: 'HOME' },
    { image: 'chica_movil', title: 'Lilimoda', at: '@Liliwoman', locator: 'WOMAN' },
    { image: 'news', title: 'Lilinews', at: '@Lilinews', locator: 'NEWS' },
    { image: 'chico', title: 'Liliman', at: '@Liliman', locator: 'MAN' },
    { image: 'bebote', title: 'Lilibaby', at: '@Lilibaby', locator: 'BABY' },
    { image: 'construcciones', title: 'Lilikids', at: '@Lilikids', locator: 'KIDS' },
    { image: 'cervecitas', title: 'Lilileisure', at: '@LilileisurePlans', locator: 'PLANS' },
    { image: 'deporte', title: 'Lilisports', at: '@Lilisports', locator: 'SPORT' },
  ];

  return (
    <div>
      {items.map((item) => {
        return <AlternativeListItem key={item.title} {...item} />;
      })}
    </div>
  );
}

function AlternativeListItem(props: any) {

  const navigate = () => {
    window.location.href = `${process.env.REACT_APP_BASE_URL}${ERoutes.WISH_LIST_PUBLIC.replace(':wishListId', props.locator)}`;
  };

  return (
    <div className='list-group-item d-flex align-items-center' style={{ height: 120, cursor: 'pointer' }} onClick={navigate}>
      <div className='col-4 col-sm-2'>
        <img src={require(`../../../assets/images/${props.image}.png`)} alt='' style={{ maxWidth: '100%', maxHeight: '100%' }} />
      </div>
      <div className='col-6 col-sm-9'>
        <b>{props.title}</b><br />{props.at}
      </div>
      <div className='col-2 col-sm-1'>
        <img src={require('../../../assets/icons/VARITA_AMARILLA.svg')} alt='' />
      </div>
    </div>
  );
}
